import React from "react";

const STATUS_CFG = {
  saved:   { color: "#4ade80", dot: "●", text: "Saved"     },
  saving:  { color: "#e8a838", dot: "◌", text: "Saving…"   },
  unsaved: { color: "#60a5fa", dot: "○", text: "Unsaved"   },
  error:   { color: "#f87171", dot: "⚠", text: "Not saved" },
};

export default function SaveBadge({ status }) {
  const cfg = STATUS_CFG[status] || { color: "#4a5e70", dot: "○", text: "" };
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 8.5, color: cfg.color }}>
      <span style={{ fontSize: 9 }}>{cfg.dot}</span>
      <span>{cfg.text}</span>
    </div>
  );
}
